import { reportInfo } from '@ms/yammer-telemetry';
import { getUserIdFromToken } from '@ms/yammer-web-authenticators';

import { isIFrame } from '../iframe';

import { checkThirdPartyCookieSupport } from './checkThirdPartyCookieSupport';

export const reportThirdPartyCookieEvent = (token?: string) => {
  let officeUserId = '';
  const isExecutingInIFrame = isIFrame();
  const isThirdPartyCookieEnabled = checkThirdPartyCookieSupport();

  if (token) {
    try {
      officeUserId = getUserIdFromToken(token);
    } catch (error) {
      console.error('Failed to get user id from token');
    }
  }

  reportInfo({
    eventName: 'third_party_cookie_set_attempt',
    eventProperties: {
      success: isThirdPartyCookieEnabled,
      isExecutingInIFrame,
      userBrowserIdentity: officeUserId,
    },
  });
};
